<template>
  <ul class="m-edition-map-tasks-list-submenu">
    <li :class="[submenuItem === 0 ? 'item-active' : 'item-inactive', 'item-left']">
      <a
        class="item-tasks-pending"
        @click.prevent="changeTaskList(0)"
      >
        <i class="fas fa-clock"></i>
        <span class="item-name margin-right-xsmall">Pendientes</span>
        ({{ pendingTasksAmount }})
      </a>
    </li>
    <li :class="submenuItem === 1 ? 'item-active' : 'item-inactive'">
      <a
        class="item-tasks-completed"
        @click.prevent="changeTaskList(1)"
      >
        <i class="fas fa-check"></i>
        <span class="item-name">Completadas</span>
      </a>
    </li>
    <li :class="[submenuItem === 2 ? 'item-active' : 'item-inactive', 'item-right']">
      <a
        class="item-tasks-rejected"
        @click.prevent="changeTaskList(2)"
      >
        <i class="fas fa-times"></i>
        <span class="item-name">Rechazadas</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionMapTasksListSubMenu',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    submenuItem: {
      type: Number,
      default: 0
    },

    pendingTasksAmount: {
      type: Number,
      default: 0
    }
  },

  methods: {
    changeTaskList (item) {
      if (!this.loading) {
        this.$emit('changeTaskList', item)
      }
    }
  }
}
</script>
